import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import vClickOutside from "v-click-outside"
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import vuetify from '@/plugins/vuetify'
import DatetimePicker from 'vuetify-datetime-picker'
import Notifications from 'vue-notification'

Vue.use(Notifications)

Vue.use(DatetimePicker)


Vue.use(VueAxios, axios, vClickOutside)
Vue.use(VueLodash, { lodash: lodash })
export const bus = new Vue();
Vue.config.productionTip = false

const ignoreWarnMessage = 'The .native modifier for v-on is only valid on components but it was used on <div>.';
Vue.config.warnHandler = function (msg) {
  if (msg === ignoreWarnMessage) {
    msg = null;
  }
}

new Vue({
  router,
  store,
  vuetify,
  delimiters: ['%%', '%%'],
  render: h => h(App)
}).$mount('#app')
